import { getRequest } from "./main";

export function getBoats() {
    return getRequest('/data/boat/boats');
};